export const LINE_VERT = `
  attribute vec3 aFlat;
  uniform float uMorph;
  varying float vBack;
  void main() {
    vec3 dir = normalize((modelMatrix * vec4(position, 1.0)).xyz);
    vBack = smoothstep(0.06, -0.06, dir.z) * (1.0 - uMorph);
    gl_Position = projectionMatrix * modelViewMatrix * vec4(mix(position, aFlat, uMorph), 1.0);
  }
`;

export const LINE_FRAG = `
  uniform vec3 uColor;
  uniform float uOpacity;
  varying float vBack;
  void main() {
    float a = uOpacity * (1.0 - vBack);
    if (a < 0.01) discard;
    gl_FragColor = vec4(uColor, a);
  }
`;
